<template>
  <v-card class="card-container">
    <v-dialog v-model="editDialog" max-width="800" persistent>
      <ManageStandardEquipment
        title="Editar equipamento padrão"
        :standardEquipment="currentStandardEquipment"
        :fromAdmin="fromAdmin"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="aboutDialog" width="600">
      <AboutStandardEquipment
        :receivedStandardEquipment="currentStandardEquipment"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir este equipamento?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="removeType"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteManyDialog" max-width="360px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              $t(
                'Tem certeza de que deseja excluir os {count} equipamentos selecionados?'.replace(
                  '{count}',
                  selectedItems.length
                )
              )
            }}
          </div>

          <v-btn
            :disabled="loadingMany"
            class="ma-1"
            color="grey"
            text
            @click="deleteManyDialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="loadingMany"
            class="ma-1"
            color="error"
            text
            @click="removeMany"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="StandartModal" max-width="500px">
      <v-card class="card-pad mx-auto" width="500">
        <div class="text-center pa-3">
          <h3>
            {{ $t('Selecione os equipamentos que deseja importar.') }}
          </h3>
          <div class="d-flex justify-center px-4">
            <v-checkbox
              class="pr-3"
              v-model="filter.workshopType"
              label="Engenharia clinica"
              :value="0"
            ></v-checkbox>
            <v-checkbox
              v-model="filter.workshopType"
              label="Manutenção predial"
              :value="1"
            ></v-checkbox>
          </div>
          <div class="d-flex justify-center px-4">
            <v-btn
              class="ma-1"
              color="grey"
              text
              @click="StandartModal = false"
            >
              Cancelar
            </v-btn>

            <v-btn
              class="ma-1"
              color="secondary"
              text
              :loading="loadingAdmin"
              :disabled="loadingAdmin"
              @click="getEquipmentFromAdmin"
            >
              {{ $t('Importar') }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="800" persistent>
      <ManageStandardEquipment
        :title="$t('Adicionar equipamento padrão')"
        :fromAdmin="fromAdmin"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <div class="main-toolbar mb-2">
      <div class="icon-back">
        <v-img
          src="../../../../assets/figmaIcons/white/patchnotes.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">
        {{
          fromAdmin != 0
            ? $t('Cadastro Padrão - Gerenciador de Equipamento Padrão')
            : $t('Equipamento Padrão')
        }}
      </span>

      <v-spacer></v-spacer>

      <v-btn
        v-if="isMaster && selectedItems.length > 0"
        dark
        depressed
        color="#FF4F64"
        class="quaternary-button mr-2 hidden-sm-and-down"
        @click="deleteManyDialog = true"
      >
        {{ $t('Excluir') }} ({{ selectedItems.length }})
      </v-btn>

      <v-btn
        color="#0F3565"
        dark
        depressed
        class="mr-4 secondary-button hidden-sm-and-down"
        @click="addStandardEquipment"
      >
        {{ $t('Novo equipamento') }}
      </v-btn>
      <v-btn
        v-if="fromAdmin == 0"
        color="#426483"
        class="mr-4 mb-0 terciary-button hidden-sm-and-down"
        @click="getStandartModal"
        dark
        :disabled="institution.status == 1"
        depressed
      >
        {{ $t('Carregar Equipamentos Padrão') }}
      </v-btn>
      <v-btn
        class="hidden-sm-and-down primary-button"
        color="#BBCF20"
        dark
        depressed
        @click="visible = !visible"
      >
        Filtros
      </v-btn>
    </div>

    <div class="hidden-md-and-up my-2">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            class="hidden-md-and-up mr-2"
            color="#0F3565"
            dark
            depressed
            @click="addStandardEquipment"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Novo Equipamento') }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            color="#426483"
            dark
            depressed
            class="mr-2 hidden-md-and-up"
            v-bind="attrs"
            v-on="on"
            @click="getEquipmentFromAdmin"
            :disabled="institution.status == 1"
          >
            <v-icon>mdi-expand-all</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Carregar Equipamentos Padrão') }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="hidden-md-and-up"
            small
            depressed
            color="#BBCF20"
            dark
            @click="visible = !visible"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon> mdi-filter </v-icon>
          </v-btn>
        </template>
        <span>Filtrar</span>
      </v-tooltip>
    </div>

    <v-expand-transition>
      <div v-show="visible">
        <v-row class="ma-0" dense>
          <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
            <label class="label">{{ $t('Equipamento') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="standardEquipmentName"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
            <label class="label">{{ $t('Sigla') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="standardEquipmentInitials"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
            <label class="label">{{ $t('Função') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="standardEquipmentFunction"
              :items="functionsEquipment"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            >
              <template v-slot:selection="{ item }">
                <span class="text-caption">
                  {{ $t(item) }}
                </span>
              </template>

              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ $t(item) }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
            <label class="label">Departamento</label>
            <v-autocomplete
              hide-details="auto"
              v-model="workshopType"
              :items="workshopTypes"
              item-text=""
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            >
              <template v-slot:selection="{ item }">
                <span class="text-caption">
                  {{ $t(item) }}
                </span>
              </template>

              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ $t(item) }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
            <label class="label">{{ $t('Risco') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="standardEquipmentRisk"
              :items="equipmentRisks"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            >
              <template v-slot:selection="{ item }">
                <span class="text-caption">
                  {{ $t(item) }}
                </span>
              </template>

              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ $t(item) }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            md="4"
            lg="4"
            class="d-flex align-center justify-end"
          >
            <v-btn
              class="mx-4 secondary-button"
              color="#BBCF20"
              depressed
              @click="filterTable"
            >
              <span>Filtrar</span>
              <v-icon class="pl-2">mdi-magnify</v-icon>
            </v-btn>

            <v-btn
              depressed
              color="#20202066"
              class="clear-button mr-0"
              @click="reset"
            >
              <span>{{ $t('Limpar') }}</span>
              <v-icon class="pl-2">mdi-cached</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <div class="wrapper mobile">
      <v-data-table
        :loading="loading"
        :loading-text="$t('Carregando...')"
        :no-data-text="$t('Nenhum equipamento encontrado')"
        :headers="headersMobile"
        :items="standardEquipments"
        class="main-table"
        hide-default-footer
        show-expand
        :items-per-page="pageSize"
        :header-props="headerProps"
        :mobile-breakpoint="330"
        :single-expand="false"
        :expanded.sync="expanded"
        @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      >
        <template #[`item.name`]="{ item }">
          {{ item.name != null ? item.name : $t('Sem registro') }}
        </template>

        <template #[`item.initials`]="{ item }">
          {{ item.initials != null ? item.initials : $t('Sem registro') }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                x-small
                color="#f5f5f5"
                style="font-weight: bold"
                dark
                @click.stop="openAbout(item)"
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-icon small color="#bbcf20">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>Detalhar</span>
          </v-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Função') }}:</strong>
                {{
                  (isNumber(item.functionEquipment)
                    ? $t(functionsEquipment[item.functionEquipment])
                    : item.functionEquipment) || $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Risco') }}:</strong>
                {{
                  (isNumber(item.equipmentRisk)
                    ? $t(equipmentRisks[item.equipmentRisk])
                    : item.equipmentRisk) || $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Exp.Vida') }}:</strong>
                {{ item.lifeExpectancy }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Oficina') }}:</strong>
                {{ item.workshopType }}
                {{
                  (isNumber(item.workshopType)
                    ? $t(workshopTypes[item.workshopType])
                    : item.workshopType) || $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Ações') }}: </strong>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ma-1"
                      color="#0F3565"
                      depressed
                      dark
                      @click="editStandardEquipment(item)"
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      :disabled="disabledButton(item)"
                    >
                      <v-icon small dark> mdi-pencil-outline </v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ma-1"
                      x-small
                      depressed
                      color="#FF4F64"
                      style="font-weight: bold"
                      dark
                      v-bind="attrs"
                      @click="deleteStandardEquipment(item)"
                      v-on="on"
                      :disabled="disabledButton(item)"
                    >
                      <v-icon small color="white">
                        mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Excluir') }}</span>
                </v-tooltip>
              </p>
            </v-col>
          </td>
        </template>
      </v-data-table>
      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span>
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>

    <div class="wrapper desktop">
      <v-data-table
        :loading="loading"
        :loading-text="$t('Carregando...')"
        :no-data-text="$t('Nenhum equipamento encontrado')"
        :headers="tableHeaders"
        :items="standardEquipments"
        hide-default-header
        class="main-table"
        hide-default-footer
        :header-props="headerProps"
        :items-per-page="pageSize"
        :show-select="isMaster"
        v-model="selectedItems"
        @click:row="editStandardEquipment"
      >
        <template #header="{ props, on }">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in props.headers"
                :key="header.value"
              >
                <v-simple-checkbox
                  v-if="header.value === 'data-table-select'"
                  v-model="props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  color="purple"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>

                <div v-else>
                  <v-hover v-slot="{ hover }">
                    <div>
                      <span>{{ $t(header.text) }}</span>
                      <v-icon
                        v-if="
                          hover &&
                          header.value != 'actions'
                        "
                        color="white"
                        class="mx-2"
                        @click="on.sort(header.value)"
                      >
                        {{
                          props.options.sortBy.includes(header.value)
                            ? `mdi-chevron-down`
                            : `mdi-chevron-up`
                        }}
                      </v-icon>
                    </div>
                  </v-hover>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #[`item.name`]="{ item }">
          {{ item.name != null ? item.name : $t('Sem registro') }}
        </template>

        <template #[`item.initials`]="{ item }">
          {{ item.initials != null ? item.initials : $t('Sem registro') }}
        </template>

        <template #[`item.functionEquipment`]="{ item }">
          {{
            (isNumber(item.functionEquipment)
              ? $t(functionsEquipment[item.functionEquipment])
              : item.functionEquipment) || $t('Sem registro')
          }}
        </template>

        <template #[`item.equipmentRisk`]="{ item }">
          {{
            (isNumber(item.equipmentRisk)
              ? $t(equipmentRisks[item.equipmentRisk])
              : item.equipmentRisk) || $t('Sem registro')
          }}
        </template>

        <template #[`item.lifeExpectancy`]="{ item }">
          {{ item.lifeExpectancy }}
        </template>

        <template #[`item.workshopType`]="{ item }">
          {{
            (isNumber(item.workshopType)
              ? $t(workshopTypes[item.workshopType])
              : item.workshopType) || $t('Sem registro')
          }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                small
                color="#f5f5f5"
                style="font-weight: bold"
                dark
                @click.stop="openAbout(item)"
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-icon color="#bbcf20">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Detalhar') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                color="#0F3565"
                @click.stop="editStandardEquipment(item)"
                v-bind="attrs"
                v-on="on"
                dark
                small
                depressed
                :disabled="disabledButton(item)"
              >
                <v-icon dark small> mdi-pencil-outline </v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                small
                color="#FF4F64"
                style="font-weight: bold"
                v-bind="attrs"
                @click.stop="deleteStandardEquipment(item)"
                v-on="on"
                depressed
                :disabled="disabledButton(item)"
              >
                <v-icon color="white"> mdi-trash-can-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Excluir') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span>
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="9"
          ></v-pagination>
        </div>
      </div>
    </div>
  </v-card>
</template>

<style scoped lang="scss">
.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import AboutStandardEquipment from './AboutStandardEquipment.vue'
import ManageStandardEquipment from './ManageStandardEquipment.vue'

export default {
  async created() {
    this.getInfo()
  },

  data: () => ({
    StandartModal: false,
    totalItensOnPage: 0,
    visible: false,
    dialog: false,
    editDialog: false,
    aboutDialog: false,
    deleteDialog: false,
    deleteManyDialog: false,
    filterDialog: false,
    dialogKey: false,
    loading: false,
    loadingAdmin: false,
    loadingMany: false,
    buttonDisabled: false,
    fromAdmin: null,
    institution: {},
    expanded: [],
    selectedItems: [],
    standardEquipments: [],
    functionsEquipment: [
      'Acessório',
      'Análise',
      'Diagnóstico',
      'Outros equipamentos de apoio',
      'Suporte à vida',
      'Terapia',
      'Simulador/Analisador/Padrão',
    ],
    equipmentRisks: [
      'Acessório',
      'Injuria',
      'Morte',
      'Sem risco',
      'Terapia ou diagnóstico inapropriado',
    ],
    workshopTypes: ['Engenharia clínica', 'Manutenção predial'],
    currentStandardEquipment: {},
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      name: null,
      initials: null,
      functionEquipment: null,
      equipmentRisk: null,
      fromAdmin: null,
      workshopType: [],
      institutionId: null,
    },
    userLogged: {},
    standardEquipmentName: null,
    standardEquipmentInitials: null,
    standardEquipmentFunction: null,
    standardEquipmentRisk: null,
    workshopType: null,
    error: false,
    headers: [
      {
        text: 'Equipamento padrão',
        align: 'center',
        value: 'name',
        sortable: false,
      },
      {
        text: 'Sigla',
        align: 'center',
        value: 'initials',
        sortable: false,
      },
      {
        text: 'Função',
        align: 'center',
        value: 'functionEquipment',
      },
      {
        text: 'Risco',
        align: 'center',
        value: 'equipmentRisk',
      },
      {
        text: 'Exp.Vida',
        align: 'center',
        value: 'lifeExpectancy',
      },
      {
        text: 'Departamento',
        align: 'center',
        value: 'workshopType',
      },
      {
        text: 'Ações',
        value: 'actions',
        sortable: false,
        width: 200,
      },
    ],
    headersMobile: [
      {
        text: 'Equipamento padrão',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Sigla',
        align: 'center',
        value: 'initials',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
  }),

  computed: {
    isMaster() {
      return this.userLogged?.mainType === 0
    },

    tableHeaders() {
      return this.headers
    },
  },

  components: {
    ManageStandardEquipment,
    AboutStandardEquipment,
  },

  methods: {
    getInfo() {
      this.fromAdmin = this.$route.query.fromAdmin
      this.institution = JSON.parse(localStorage.getItem('institution'))
      this.userLogged = JSON.parse(localStorage.getItem('user'))
      this.filter.workshopType = []
      this.updateType()
    },

    isNumber(value) {
      return typeof value === 'number'
    },

    disabledButton(item) {
      return (
        this.fromAdmin == 0 &&
        item.isFromAdmin &&
        this.institution.userType > 3 &&
        this.institution.userType != 8
      )
    },

    addStandardEquipment() {
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    editStandardEquipment(equipament) {
      this.currentStandardEquipment = equipament
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },

    deleteStandardEquipment(equipament) {
      this.currentStandardEquipment = equipament
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.aboutDialog = false

      this.updateType()
    },

    openAbout(equipament) {
      this.currentStandardEquipment = equipament
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.name = this.standardEquipmentName
      this.filter.initials = this.standardEquipmentInitials
      this.filter.functionEquipment = this.functionsEquipment.indexOf(
        this.standardEquipmentFunction
      )
      this.filter.equipmentRisk = this.equipmentRisks.indexOf(
        this.standardEquipmentRisk
      )

      this.filter.workshopType = []

      const type = this.workshopTypes.indexOf(this.workshopType)
      if (type > -1) {
        this.filter.workshopType.push(type)
      }

      this.updateType()
    },

    async updateTable() {
      this.loading = true
      this.filter.fromAdmin = this.fromAdmin
      this.filter.institutionId = this.institution.id

      await this.apiService
        .post('institutionStandardEquipment/listByInstitution', this.filter)
        .then((response) => {
          this.standardEquipments = []
          this.standardEquipments = response.content.equipments

          this.totalPages = response.content.pager.totalPages
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.equipments.length
          this.loading = false
        })
    },

    async updateTableFromAdmin() {
      this.loading = true
      this.filter.fromAdmin = this.fromAdmin

      await this.apiService
        .post('standardEquipment/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.standardEquipments = response.content.standardEquipment
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.standardEquipment.length
          this.loading = false
        })
    },

    getStandartModal() {
      if (this.institution.departmentTypes.length > 1) {
        this.StandartModal = true
      } else {
        this.filter.workshopType = this.institution.departmentTypes
        this.getEquipmentFromAdmin()
      }
    },

    async getEquipmentFromAdmin() {
      this.loadingAdmin = true
      this.filter.institutionId = this.institution.id

      await this.apiService
        .post('standardEquipment/getFromAdmin', this.filter)
        .then((response) => {
          this.StandartModal = false
          this.filter.workshopType = []
          this.updateTable()
        })
        .finally(() => {
          this.loadingAdmin = false
        })
    },

    removeType() {
      if (this.fromAdmin == 0) {
        this.remove()
      } else {
        this.removeFromAdmin()
      }
    },

    async removeFromAdmin() {
      this.loading = true

      await this.apiService
        .delete(
          'standardEquipment/deleteFromAdmin',
          this.currentStandardEquipment
        )
        .then(() => {
          this.loading = false
          this.deleteDialog = false
          this.updateType()
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })
    },

    async remove() {
      this.loading = true

      let standardEquipment = {
        StandardEquipment: this.currentStandardEquipment,
        InstitutionId: this.institution.id,
      }

      let url = 'standardEquipment/delete'

      if (this.fromAdmin == 0) {
        url = 'institutionStandardEquipment/delete'
        standardEquipment = this.currentStandardEquipment
      }

      await this.apiService
        .delete(url, standardEquipment)
        .then(() => {
          this.loading = false
          this.deleteDialog = false
          this.updateType()
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })
    },

    async removeMany() {
      this.loadingMany = true

      const ids = this.selectedItems.map((item) => item.id)
      const url =
        this.fromAdmin == 0
          ? 'institutionStandardEquipment/delete-Many'
          : 'standardEquipment/deleteMany'

      await this.apiService
        .delete(url, ids)
        .then(() => {
          this.selectedItems = []
          this.deleteManyDialog = false
          this.updateType()
        })
        .catch(() => {
          this.deleteManyDialog = false
        })
        .finally(() => {
          this.loadingMany = false
        })
    },

    async updateType() {
      if (this.fromAdmin == 1) {
        this.updateTableFromAdmin()
      } else {
        this.updateTable()
      }
    },

    reset() {
      this.standardEquipmentName = null
      this.standardEquipmentInitials = null
      this.standardEquipmentFunction = null
      this.standardEquipmentRisk = null
      this.workshopType = null

      this.filter = {
        page: 1,
        pageSize: 10,
        name: null,
        initials: null,
        functionEquipment: null,
        equipmentRisk: null,
        workshopType: [],
      }
      this.updateType()
      this.filterDialog = false
    },
  },

  watch: {
    $route() {
      this.getInfo()
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateType()
    },

    page() {
      this.filter.page = this.page
      this.updateType()
    },
  },
}
</script>
